import React from 'react';
import { Select } from 'antd';

// Custom dropdown icon giống select HTML thông thường
const DropdownIcon = () => (
    <svg 
        width="14" 
        height="8" 
        viewBox="0 0 14 8" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
    >
        <path 
            d="M1 1L7 7L13 1" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
);

const FilterSelect = ({ 
    placeholder, 
    value, 
    onChange, 
    onClear,
    options = [],
    loading = false,
    allowClear = true,
    optionValueKey = 'value',
    optionLabelKey = 'label',
    ...props 
}) => {
    return (
        <Select
            placeholder={placeholder}
            value={value || undefined}
            onChange={onChange}
            onClear={onClear}
            allowClear={allowClear}
            loading={loading}
            className="filter-select"
            suffixIcon={<DropdownIcon />}
            {...props}
        >
            {options.map(option => (
                <Select.Option 
                    value={option[optionValueKey]} 
                    key={option[optionValueKey]}
                >
                    {option[optionLabelKey]}
                </Select.Option>
            ))}
        </Select>
    );
};

export default FilterSelect;
